(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@jupyter-widgets/base"));
	else if(typeof define === 'function' && define.amd)
		define(["@jupyter-widgets/base"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@jupyter-widgets/base")) : factory(root["@jupyter-widgets/base"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__133__) {
return 